import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DirectivesModule } from '@backoffice-frontend/shared/directives/common';
import { StandardizedLoadProfilePermissions } from '@backoffice/shared/bo/util-permissions';
import {
    ListFacade,
} from '@clean-code/backoffice/standardized-load-profile/domain';
import { StandardizedLoadProfile } from '@clean-code/models';
import { ActionButtonModule } from '@clean-code/shared/components/ui-action-button';
import { DataTableBaseComponent } from '@clean-code/shared/components/ui-data-table';
import {
    TableStateService,
    UiMatTableModule,
} from '@clean-code/shared/components/ui-mat-table';
import { PageContainerModule } from '@clean-code/shared/components/ui-page-container';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { TranslocoModule } from '@jsverse/transloco';
import { NgxPermissionsModule } from 'ngx-permissions';
import { StandardizedLoadProfileSearchComponent } from './standardized-load-profile-search/standardized-load-profile-search.component';
@Component({
  selector: 'backoffice-standardized-load-profile-list',
  templateUrl: './standardized-load-profile-list.component.html',
  styles: ['.icon { font-size:20px;}'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    TranslocoModule,
    FontAwesomeModule,
    NgxPermissionsModule,
    UiMatTableModule,
    ActionButtonModule,
    DirectivesModule,
    PageContainerModule,
    StandardizedLoadProfileSearchComponent,
  ],
  providers: [TableStateService],
})
export class StandardizedLoadProfileListComponent extends DataTableBaseComponent<StandardizedLoadProfile> {
  protected override navigateUrl = '/standardized-load-profiles';

  public faCheck = faCheck;

  public standardizedLoadProfilePermissions = StandardizedLoadProfilePermissions;

  constructor(protected service: ListFacade) {
    super(service);
  }

  public override add() {
    void this.router.navigate(['/standardized-load-profile/new']);
  }
}
